/**
 * the Entity Data Model module
 */

import { IEdm, IEDMOptions } from './types';

import typesPlugin from './types-plugin';
import schemaPlugin from './schema-plugin';

export class EDM implements IEdm {
  constructor(options?: IEDMOptions) {
    typesPlugin(this);
    if (options) {
      schemaPlugin(this, options);
    }
  }
}

// eslint-disable-next-line no-redeclare
export interface EDM extends IEdm {}
